module.exports = __webpack_public_path__ + "static/media/biker.1a043397.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/personal/thumbs/biker.jpg
// module id = 439
// module chunks = 0